import {useMutation} from '@tanstack/react-query'
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import useCustomShopperContext from './use-custom-shopper-context'
import {doCustomAPICall} from '../utils/custom-api-utils'
import {getUserIdentifiers, trackTAPurchaseEvent} from '../utils/custom-utils'

export const useTrackThinkAnalyticsEvents = () => {
    const {getTokenWhenReady} = useAccessToken()
    const config = getConfig()
    const appOrigin = useAppOrigin()
    const {data: customer} = useCurrentCustomer()
    const shopperGeoLocation = useCustomShopperContext()
    const userAgent = typeof window !== 'undefined' ? window?.navigator?.userAgent : ''

    return useMutation({
        mutationFn: async ({c_productId, c_refUseCase = '', c_useCase, additionalData = {}}) => {
            if (!c_productId || !c_useCase) {
                throw new Error('c_productId and c_useCase are required')
            }
            const {userID, householdId} = getUserIdentifiers(customer)
            const c_countryCode = shopperGeoLocation?.CountryCode || 'US'
            const c_regionCode = shopperGeoLocation?.RegionCode || ''
            const c_timeZone =
                shopperGeoLocation?.timeZone ||
                Intl.DateTimeFormat().resolvedOptions().timeZone ||
                ''
            const c_userAgent = userAgent

            // Skip if any of the critical values are still missing
            if (!c_countryCode || !c_userAgent || !c_timeZone) {
                return null
            }

            const apiPath = `think-analytics/trackTAEvent?`
            const isPLPPage =
                typeof window !== 'undefined' && window.location.pathname.includes('/collections')
            const isSearch = additionalData?.isSearch === true
            if (c_useCase === 'Store%2FLearn%2FAddToCart' && c_refUseCase !== 'CRSTORE') {
                trackTAPurchaseEvent(c_productId, c_refUseCase, c_countryCode, c_regionCode)
            }

            if (
                c_useCase != 'Store%2FLearn%2FAddToCart' &&
                ((!isPLPPage && !isSearch) ||
                    (!isPLPPage && !isSearch && c_useCase === 'Store%2FLearn%2FClickedOnSearch'))
            ) {
                return null
            }

            const reqBody = {
                c_productId,
                c_refUseCase,
                c_useCase,
                c_timeZone,
                c_householdId: householdId,
                c_userID: userID,
                c_countryCode,
                c_regionCode,
                c_userAgent
            }

            return doCustomAPICall(getTokenWhenReady, {
                config,
                appOrigin,
                customAPIFolderName: 'think-analytics',
                apiPath,
                reqParams: {
                    method: 'POST',
                    reqBody
                }
            })
        }
    })
}
